module.exports = __webpack_public_path__ + "images/9fdcfce7703b16cffcdf0b21a249bbc1-bedroom-style3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/bedroom-style3.jpg
// module id = ./src/assets/images/content/bedroom-style3.jpg
// module chunks = 0